import { upperCase as up } from '@/utils'

export default {
  'th-TH': {
    name: 'ภาษาไทย',
    continent: 'Asia Pacific',

    // Text.
    noMatch: 'ข้อมูลไม่ตรงกัน',
    notFound: 'ค้นหาไม่พบ',
    loading: 'กำลังโหลด',
    viewMore: 'ดูเพิ่มเติม',
    auth: 'การยืนยันตัวตน',
    project: 'ยินดีต้อนรับสู่ %{msg} - Project',

    // Input field name.
    email: 'ที่อยุ่ E-Mail',
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    logged: 'ให้ฉันคงอยู่ในระบบ',
    enabled: 'เปิดการใช้งาน',
    disabled: 'ปิดการใช้งาน',
    labelName: 'ชื่อ',
    displayName: 'Display Name',
    search: 'ค้นหา',
    status: 'สถานะ',
    active: 'สถานะ',
    right: 'ระดับสิทธิผู้ใช้',

    // Menu.
    dashboard: 'แผงควบคุม',
    stream: 'สตรีมสด',
    users: 'จัดการสิทธิการใช้งานผู้ใช้',
    cog: 'การกำหนดค่าระบบ',
    profile: 'จัดการบัญชี',

    account: 'บัญชีผู้ใช้',
    permission: 'สิทธิการใช้งาน',
    view: 'View | Views',

    camera: 'กล้อง',
    business: 'องค์กร',
    city: 'จังหวัด',
    branch: 'สาขา',
    area: 'พื้นที่',

    button: {
      signin: 'เข้าสู่ระบบ',
      signout: 'ออกจากระบบ',
      submit: 'ส่งข้อมูล',
      save: 'บันทึก',
      apply: 'นำไปใช้',
      confirm: 'ยืนยัน',
      cancel: 'ยกเลิก',
      clear: 'ล้างข้อมูล',
      back: 'ย้อนกลับ',
      reset: 'รีเซ็ต',
      enable: 'เปิดการใช้งาน',
      on: 'เปิด',
      off: 'ปิด',
      edit: 'แก้ไข',
      modify: 'แก้ไข',
      remove: 'ลบทิ้ง',
      copy: 'คักลอก',
      download: 'ดาวน์โหลด'
    },

    // Errors messages.
    errors: {
      _default  : (field: any) => `ข้อมูล ${up(field)} ไม่ถูกต้อง`,
      alpha     : (field: any) => `${up(field)} ต้องเป็นตัวอักษรเท่านั้น`,
      alpha_num : (field: any) => `${up(field)} ต้องเป็นตัวอักษร และตัวเลขเท่านั้น`,
      confirmed : (field: any) => `การยืนยันข้อมูลของ ${up(field)} ไม่ตรงกัน`,
      email     : (field: any) => `${up(field)} ต้องเป็นรูปแบบอีเมล`,
      max       : (field: any, [length]: any) => `${up(field)} ต้องมีความยาวไม่เกิน ${length} ตัวอักษร`,
      min       : (field: any, [length]: any) => `${up(field)} ต้องมีความยาวอย่างน้อย ${length} ตัวอักษร`,
      required  : (field: any) => `กรุณากรอก ${up(field)}`
    }
  }
}